import { removeRecentView, type RecentViewKind } from '@/utils/recentlyViewed';
import type { RecentViewIdentity } from '@/hooks/useRecentViewIdentity';

/**
 * The "Remove from Shared with me" button a revoked share offers on its
 * not-found screen (ENG-2009), or `undefined` when it should not be offered.
 *
 * Withheld until the bucket is known: a 404 returns fast and can beat
 * `/auth/current`, and removing from the wrong bucket leaves the dead row in
 * place with no second chance at it from the dashboard.
 */
export function recentRemoveAction(
  identity: RecentViewIdentity,
  kind: RecentViewKind,
  id: string,
  label: string,
  onDone: () => void,
): { label: string; onClick: () => void } | undefined {
  if (!identity.ready) return undefined;
  return {
    label,
    onClick: () => {
      removeRecentView(identity.userId, kind, id);
      onDone();
    },
  };
}
